(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/regenerator', 'babel-runtime/helpers/extends', 'babel-runtime/helpers/asyncToGenerator', 'react', './client'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/regenerator'), require('babel-runtime/helpers/extends'), require('babel-runtime/helpers/asyncToGenerator'), require('react'), require('./client'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global._extends, global.asyncToGenerator, global.react, global.client);
    global.RedirectToLogin = mod.exports;
  }
})(this, function (exports, _regenerator, _extends2, _asyncToGenerator2, _react, _client) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.RedirectToSignup = exports.redirectToSignup = exports.redirectToLogin = undefined;

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _extends3 = _interopRequireDefault(_extends2);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _client2 = _interopRequireDefault(_client);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var redirectToLogin = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var returnTo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
      var authorizationParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _client2.default.loginWithRedirect({
                authorizationParams: (0, _extends3.default)({
                  scope: 'openid profile email offline_access'
                }, authorizationParams),
                appState: { returnTo: returnTo }
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function redirectToLogin() {
      return _ref.apply(this, arguments);
    };
  }();

  var redirectToSignup = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var returnTo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
      var authorizationParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', redirectToLogin(returnTo, (0, _extends3.default)({
                screen_hint: 'signup'
              }, authorizationParams)));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined);
    }));

    return function redirectToSignup() {
      return _ref2.apply(this, arguments);
    };
  }();

  var RedirectToLogin = function RedirectToLogin(_ref3) {
    var _ref3$returnTo = _ref3.returnTo,
        returnTo = _ref3$returnTo === undefined ? window.location.href : _ref3$returnTo,
        _ref3$authorizationPa = _ref3.authorizationParams,
        authorizationParams = _ref3$authorizationPa === undefined ? {} : _ref3$authorizationPa;

    (0, _react.useEffect)(function () {
      redirectToLogin(returnTo, authorizationParams);
    }, []);

    return null;
  };

  var RedirectToSignup = function RedirectToSignup(_ref4) {
    var _ref4$returnTo = _ref4.returnTo,
        returnTo = _ref4$returnTo === undefined ? window.location.href : _ref4$returnTo,
        _ref4$authorizationPa = _ref4.authorizationParams,
        authorizationParams = _ref4$authorizationPa === undefined ? {} : _ref4$authorizationPa;

    (0, _react.useEffect)(function () {
      redirectToSignup(returnTo, authorizationParams);
    }, []);

    return null;
  };

  exports.default = RedirectToLogin;
  exports.redirectToLogin = redirectToLogin;
  exports.redirectToSignup = redirectToSignup;
  exports.RedirectToSignup = RedirectToSignup;
});